module.exports = __webpack_public_path__ + "static/media/bread-loaf.dcc2a953.svg";